export const LoginItems = [
    {
      label: "Login",
      link: "#",
      children: [
        {
          label: "Teachers",
          link: "/login-teacher",
        },
        {
          label: "Student",
          link: "/login-student",
        },
  
        {
          label: "Guest",
          link: "/login-guest",
        },
  
      ],
    },
  ];
  
  export const navItems = [
    {
      label: "Student Centre",
      link: "/",
      children: [
        {
          label: "Students Learning Centre",
          link: "/students-page"
        },
        {
          label: "Vocational Centre",
          link: "/students-vocational",
        },
  
        {
          label: "Special Needs",
          link: "/students-special-needs",
        },
        {
          label: "Student Fun Centre Game",
          link: "/students-game-centre",
        },
      ],
    },
    {
      label: " ERC (store)",
      link: "/store",
    },
    {
      label: " Guidance & Counseling",
      link: "/guidance-counselling",
    },
    {
      label: "Teacher Training",
      link: "/",
      children: [
        {
          label: "Professional Courses",
          link: "/teachers-professional",
        },
        {
          label: "Special/Audio-Visual Capacity",
          link: "/teachers-page",
        },
      ],
    },
    {
      label: "Special Needs",
      link: "/",
      children: [
        {
          label: "Learning Courses",
          link: "/students-special-needs",
        },
        {
          label: "Game",
          link: "/students-game-centre",
        },
        {
          label: "Child Guidiance & Counselling",
          link: "/guidance-counselling",
        },
      ],
    },
  ];
  